"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.s3MetaConfigSchema = exports.S3MetaConfigSchemaObj = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const bucketNameRegex = /^(?!^(\d{1,3}\.){3}\d{1,3}$)(?!.*\.\.)(?!-)(?!.*-$)[a-z0-9][a-z0-9.-]{1,48}[a-z0-9]$/;
exports.S3MetaConfigSchemaObj = {
    name: yup_lib_1.default
        .string()
        .required()
        .matches(bucketNameRegex, `The S3 bucket name must consist of 3 to 50 characters, including lowercase letters, numbers, hyphens, and dots.
      It cannot look like an IP address, contain spaces, or include consecutive dots (..). Additionally, 
      it must not start or end with a hyphen. 
    Example: "my.bucket-name"`)
        .label('Bucket Name'),
    location: yup_lib_1.default.string()
};
exports.s3MetaConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.S3MetaConfigSchemaObj);
